enum TorizonUpdateStatus {
  IDLE = 'IDLE',
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS',
}

export default TorizonUpdateStatus;
